import { jsx as _jsx } from "react/jsx-runtime";
import { t } from '@/core/localization';
import clipboardIcon from '@/core/svg/fa/clipboard.svg';
import { forwardRef } from 'react';
import { ActionIconTemplate } from './ActionIconTemplate';
export const CopyToClipboardActionIcon = forwardRef((props, ref) => {
    return _jsx(ActionIconTemplate, { ref: ref, ...props, icon: clipboardIcon, defaultTitle: t('copy.to.clipboard') });
});
